import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_RowClass} from '../../dbschema/bl_fi_mst_branch.model';
import {bl_fi_mst_branch_ext_RowClass} from '../../dbschema/bl_fi_mst_branch_ext.model';
import {bl_fi_mst_comp_RowCLass} from '../../dbschema/bl_fi_mst_comp.model';
import {bl_fi_mst_comp_ext_RowClass} from '../../dbschema/bl_fi_mst_comp_ext.model';
import { bl_fi_mst_entity_branch_hdr_RowClass } from '../../dbschema/bl_fi_mst_entity_branch_hdr.model';

export class IntercompanyContainerModel extends BaseContainerModel{
    bl_fi_mst_comp: bl_fi_mst_comp_RowCLass = new bl_fi_mst_comp_RowCLass();
    bl_fi_mst_comp_ext: bl_fi_mst_comp_ext_RowClass[] = [];
    bl_fi_mst_branch: bl_fi_mst_branch_RowClass = new bl_fi_mst_branch_RowClass();
    bl_fi_mst_branch_ext: bl_fi_mst_branch_ext_RowClass[] = [];
    bl_fi_mst_entity_branch_hdr: bl_fi_mst_entity_branch_hdr_RowClass = new bl_fi_mst_entity_branch_hdr_RowClass();   
}
